import { Component, OnInit, Input } from '@angular/core';
import { NavParams, PopoverController } from '@ionic/angular';
@Component({
  selector: 'app-prompt',
  templateUrl: './prompt.component.html',
  styleUrls: ['./prompt.component.scss'],
})
export class PromptComponent implements OnInit {
  // tslint:disable-next-line: no-input-rename
  @Input('mobileType') mobileType: any;
  // tslint:disable-next-line: no-input-rename
  @Input('promptEvent') promptEvent: any;

  constructor(
    public navParams: NavParams,
    public popoverCtrl: PopoverController
  ) { }

  ngOnInit() {

  }

  public installPwa(): void {
    this.promptEvent.prompt();
    this.close();
  }

  public close() {
    this.popoverCtrl.dismiss();
  }
}
